import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PageBanner } from '../components/PageBanner';
import { Button } from '../components/ui/Button';
import { CalendarIcon, ClockIcon, ScissorsIcon } from 'lucide-react';
export function BookingPage() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  return <>
      <PageBanner title="Book Your Appointment" subtitle="Reserve your time with our master braiders." backgroundImage="https://cdn.magicpatterns.com/uploads/h8BZswf9FXnbCao6SBRdP9/pexels-_brunovisual-1157201511-32426330.jpg" data-id="element-537" />

      <section className="py-24 bg-cream relative" data-id="element-538">
        <div className="absolute inset-0 pattern-dots opacity-10" data-id="element-539"></div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-540">
          <div className="bg-white rounded-sm shadow-xl overflow-hidden border border-brown/10" data-id="element-541">
            <div className="grid grid-cols-1 md:grid-cols-3" data-id="element-542">
              {/* Info Sidebar */}
              <div className="bg-jet text-white p-8 md:p-10 flex flex-col justify-between" data-id="element-543">
                <div data-id="element-544">
                  <h3 className="text-2xl font-heading font-bold text-golden mb-6" data-id="element-545">
                    Booking Policies
                  </h3>
                  <ul className="space-y-6 text-sm text-white/70" data-id="element-546">
                    <li className="flex gap-3" data-id="element-547">
                      <ClockIcon className="w-5 h-5 text-golden shrink-0" data-id="element-548" />
                      <span data-id="element-549">
                        Please arrive 10 minutes before your scheduled
                        appointment time.
                      </span>
                    </li>
                    <li className="flex gap-3" data-id="element-550">
                      <ScissorsIcon className="w-5 h-5 text-golden shrink-0" data-id="element-551" />
                      <span data-id="element-552">
                        Hair must be washed, detangled, and blow-dried prior to
                        arrival unless adding a wash service.
                      </span>
                    </li>
                    <li className="flex gap-3" data-id="element-553">
                      <CalendarIcon className="w-5 h-5 text-golden shrink-0" data-id="element-554" />
                      <span data-id="element-555">
                        A $50 non-refundable deposit is required to secure your
                        slot.
                      </span>
                    </li>
                  </ul>
                </div>

                <div className="mt-12 pt-8 border-t border-white/10" data-id="element-556">
                  <p className="text-sm text-white/50 italic" data-id="element-557">
                    "Your hair is your crown. We can't wait to help you wear it
                    with pride."
                  </p>
                </div>
              </div>

              {/* Form Area */}
              <div className="p-8 md:p-10 md:col-span-2 bg-white" data-id="element-558">
                {isSuccess ? <motion.div initial={{
                opacity: 0,
                scale: 0.9
              }} animate={{
                opacity: 1,
                scale: 1
              }} className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-559">
                    <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-560">
                      <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-561">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-562"></path>
                      </svg>
                    </div>
                    <h3 className="text-3xl font-heading font-bold text-jet mb-4" data-id="element-563">
                      Request Received!
                    </h3>
                    <p className="text-jet/60 mb-8 max-w-md" data-id="element-564">
                      Thank you for choosing Rozii African Hair Braiding. We've
                      received your booking request and will contact you shortly
                      to confirm your appointment and collect the deposit.
                    </p>
                    <Button variant="outline" onClick={() => setIsSuccess(false)} data-id="element-565">
                      Book Another Service
                    </Button>
                  </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-566">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-567">
                      <div className="space-y-2" data-id="element-568">
                        <label htmlFor="firstName" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-569">
                          First Name
                        </label>
                        <input type="text" id="firstName" required className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-sm focus:outline-none focus:ring-2 focus:ring-burgundy focus:border-transparent transition-all" placeholder="Jane" data-id="element-570" />
                      </div>
                      <div className="space-y-2" data-id="element-571">
                        <label htmlFor="lastName" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-572">
                          Last Name
                        </label>
                        <input type="text" id="lastName" required className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-sm focus:outline-none focus:ring-2 focus:ring-burgundy focus:border-transparent transition-all" placeholder="Doe" data-id="element-573" />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-574">
                      <div className="space-y-2" data-id="element-575">
                        <label htmlFor="email" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-576">
                          Email Address
                        </label>
                        <input type="email" id="email" required className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-sm focus:outline-none focus:ring-2 focus:ring-burgundy focus:border-transparent transition-all" placeholder="jane@example.com" data-id="element-577" />
                      </div>
                      <div className="space-y-2" data-id="element-578">
                        <label htmlFor="phone" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-579">
                          Phone Number
                        </label>
                        <input type="tel" id="phone" required className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-sm focus:outline-none focus:ring-2 focus:ring-burgundy focus:border-transparent transition-all" placeholder="(240) 921-7857" data-id="element-580" />
                      </div>
                    </div>

                    <div className="space-y-2" data-id="element-581">
                      <label htmlFor="service" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-582">
                        Select Service
                      </label>
                      <select id="service" required className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-sm focus:outline-none focus:ring-2 focus:ring-burgundy focus:border-transparent transition-all appearance-none" data-id="element-583">
                        <option value="" data-id="element-584">Choose a style...</option>
                        <option value="knotless" data-id="element-585">
                          Knotless Braids (From $180)
                        </option>
                        <option value="box" data-id="element-586">Box Braids (From $150)</option>
                        <option value="cornrows" data-id="element-587">Cornrows (From $80)</option>
                        <option value="goddess" data-id="element-588">
                          Goddess Braids (From $165)
                        </option>
                        <option value="faux-locs" data-id="element-589">Faux Locs (From $200)</option>
                        <option value="twists" data-id="element-590">
                          Senegalese Twists (From $160)
                        </option>
                        <option value="other" data-id="element-591">Other / Consultation</option>
                      </select>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-592">
                      <div className="space-y-2" data-id="element-593">
                        <label htmlFor="date" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-594">
                          Preferred Date
                        </label>
                        <input type="date" id="date" required className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-sm focus:outline-none focus:ring-2 focus:ring-burgundy focus:border-transparent transition-all" data-id="element-595" />
                      </div>
                      <div className="space-y-2" data-id="element-596">
                        <label htmlFor="time" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-597">
                          Preferred Time
                        </label>
                        <select id="time" required className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-sm focus:outline-none focus:ring-2 focus:ring-burgundy focus:border-transparent transition-all appearance-none" data-id="element-598">
                          <option value="" data-id="element-599">Choose a time...</option>
                          <option value="morning" data-id="element-600">Morning (9AM - 12PM)</option>
                          <option value="afternoon" data-id="element-601">
                            Afternoon (12PM - 4PM)
                          </option>
                          <option value="evening" data-id="element-602">Evening (4PM - 7PM)</option>
                        </select>
                      </div>
                    </div>

                    <div className="space-y-2" data-id="element-603">
                      <label htmlFor="notes" className="block text-sm font-medium text-jet uppercase tracking-wider" data-id="element-604">
                        Additional Notes
                      </label>
                      <textarea id="notes" rows={4} className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-sm focus:outline-none focus:ring-2 focus:ring-burgundy focus:border-transparent transition-all resize-none" placeholder="Tell us about your hair length, density, or any specific requests..." data-id="element-605"></textarea>
                    </div>

                    <Button type="submit" variant="primary" size="lg" className="w-full" disabled={isSubmitting} data-id="element-606">
                      {isSubmitting ? 'Processing...' : 'Request Appointment'}
                    </Button>
                  </form>}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}